/**
 * KRS Featured Properties Carousel
 * Vanilla JS - no external dependencies
 * Initializes per section by section.id
 */
(function() {
    'use strict';
  
    var KRSFeaturedPropertiesCarousel = {
      instances: {},

      setupInquiry: function(root) {
        if (root.dataset.krsInquiryBound === 'true') return;
        var dialog = root.querySelector('.krs-fpc__inquiry-dialog');
        if (!dialog) return;
        var form = dialog.querySelector('.krs-fpc__inquiry-form');
        if (!form) return;
        root.dataset.krsInquiryBound = 'true';
        var preview = dialog.querySelector('[data-inquiry-preview]');
        var bodyHidden = form.querySelector('input[name="contact[body]"]');
        var msgEl = form.querySelector('.krs-fpc__inquiry-textarea');
        var closeEls = dialog.querySelectorAll('[data-inquiry-close]');
        var gdpr = form.querySelector('[data-inquiry-gdpr]');
        var gdprErr = form.querySelector('[data-gdpr-err]');
        var lastInquiryButton = null;

        function getFields() {
          return {
            title: dialog.querySelector('[data-inquiry-field="title"]'),
            location: dialog.querySelector('[data-inquiry-field="location"]'),
            details: dialog.querySelector('[data-inquiry-field="details"]'),
            price: dialog.querySelector('[data-inquiry-field="price"]'),
            rule: dialog.querySelector('.krs-fpc__inquiry-preview__rule')
          };
        }

        function fillFromButton(btn) {
          var t = (btn.getAttribute('data-inquiry-title') || '').trim();
          var u = (btn.getAttribute('data-inquiry-url') || '').trim();
          var loc = (btn.getAttribute('data-inquiry-location') || '').trim();
          var det = (btn.getAttribute('data-inquiry-details') || '').trim();
          var price = (btn.getAttribute('data-inquiry-price') || '').trim();
          var f = getFields();
          if (f.title) {
            f.title.textContent = t || '—';
          }
          if (f.location) {
            f.location.textContent = loc;
            f.location.style.display = loc ? 'block' : 'none';
          }
          if (f.details) {
            f.details.textContent = det;
            f.details.style.display = det ? 'block' : 'none';
          }
          if (f.price) {
            var pLine = price ? ('Цена: ' + price) : '';
            f.price.textContent = pLine;
            f.price.style.display = price ? 'block' : 'none';
          }
          if (f.rule) {
            var showRule = !!price;
            f.rule.style.display = showRule ? 'block' : 'none';
          }
          lastInquiryButton = btn;
        }

        function buildPrefix() {
          var b = lastInquiryButton;
          if (!b) {
            return '--- Запитване за имот ---\n\n';
          }
          function g(name) {
            return ((b.getAttribute('data-inquiry-' + name) || '') + '').trim();
          }
          var t = g('title');
          var u = g('url');
          var loc = g('location');
          var det = g('details');
          var price = g('price');
          var lines = ['--- Запитване за имот ---', ''];
          if (t) lines.push('Имот: ' + t);
          if (u) lines.push('Линк: ' + u);
          if (loc) lines.push('Локация: ' + loc);
          if (det) lines.push(det);
          if (price) lines.push('Цена: ' + price);
          lines.push('');
          return lines.join('\n');
        }

        function openFrom(btn) {
          fillFromButton(btn);
          if (bodyHidden) bodyHidden.value = '';
          if (msgEl) msgEl.value = '';
          if (gdpr) gdpr.checked = false;
          if (gdprErr) gdprErr.hidden = true;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
            var first = form.querySelector('input[name="contact[name]"], input[type="text"], input[type="email"]');
            if (first) {
              setTimeout(function() { first.focus(); }, 50);
            }
          }
        }

        function closeD() {
          if (typeof dialog.close === 'function' && dialog.open) {
            dialog.close();
          }
        }

        root.addEventListener('click', function(e) {
          var btn = e.target.closest('.krs-fpc__inquiry-open');
          if (!btn || !root.contains(btn)) return;
          e.preventDefault();
          openFrom(btn);
        });

        closeEls.forEach(function(c) {
          c.addEventListener('click', function() { closeD(); });
        });

        dialog.addEventListener('click', function(e) {
          if (e.target === dialog) {
            closeD();
          }
        });

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (gdpr && !gdpr.checked) {
            if (gdprErr) gdprErr.hidden = false;
            gdpr.focus();
            return;
          }
          if (gdprErr) gdprErr.hidden = true;
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            form.reportValidity();
            return;
          }
          if (bodyHidden) {
            var userMsg = msgEl && msgEl.value ? msgEl.value.trim() : '';
            bodyHidden.value =
              buildPrefix() +
              (userMsg ? ('\n\n--- Съобщение ---\n' + userMsg) : '\n\n--- Съобщение ---\n(празно съобщение.)');
            setTimeout(function() {
              form.submit();
            }, 0);
          }
        });
      },

      init: function(root) {
        if (!root || root.dataset.initialized === 'true') return;

        var sectionId = root.getAttribute('data-section-id');
        if (!sectionId) return;

        this.setupInquiry(root);

        var carousel = root.querySelector('.krs-fpc__carousel');
        var track = root.querySelector('.krs-fpc__track');
        var cards = root.querySelectorAll('.krs-fpc__card');
        var prevBtn = root.querySelector('.krs-fpc__arrow--prev');
        var nextBtn = root.querySelector('.krs-fpc__arrow--next');
        var dotsContainer = root.querySelector('.krs-fpc__dots');
  
        if (!carousel || !track || !cards.length) return;
  
        var cardsDesktop = parseInt(root.dataset.cardsDesktop || '4', 10);
        var cardsTablet = parseInt(root.dataset.cardsTablet || '2', 10);
        var cardsMobile = parseInt(root.dataset.cardsMobile || '1', 10);
        var showDots = root.dataset.showDots === 'true';
        var showArrows = root.dataset.showArrows === 'true';
        var i18nPage = root.dataset.i18nPage || 'Страница';
        var i18nOf = root.dataset.i18nOf || 'от';
        var i18nFavAdd = root.dataset.i18nFavoriteAdd || 'Добави в любими';
        var i18nFavRemove = root.dataset.i18nFavoriteRemove || 'Премахни от любими';
  
        var state = {
          cardsPerPage: cardsDesktop,
          totalPages: 1,
          currentPage: 0,
          resizeObserver: null,
          scrollListener: null
        };
  
        function getCardsPerPage() {
          var w = root.offsetWidth;
          if (w < 750) return cardsMobile;
          if (w < 990) return cardsTablet;
          return cardsDesktop;
        }
  
        function updatePages() {
          state.cardsPerPage = getCardsPerPage();
          state.totalPages = Math.max(0, Math.ceil(cards.length / state.cardsPerPage));
          updateDots();
          updateArrows();
        }
  
        function getPageWidth() {
          var cardWidth = cards[0] ? cards[0].offsetWidth : 0;
          var gap = getGap();
          return state.cardsPerPage * cardWidth + (state.cardsPerPage - 1) * gap;
        }
  
        function getCurrentPage() {
          var scrollLeft = carousel.scrollLeft;
          var pageWidth = getPageWidth();
          if (pageWidth <= 0 || state.totalPages === 0) return 0;
          var page = Math.round(scrollLeft / pageWidth);
          return Math.min(Math.max(0, page), Math.max(0, state.totalPages - 1));
        }
  
        function getGap() {
          var trackStyle = window.getComputedStyle(track);
          return parseFloat(trackStyle.gap) || 24;
        }
  
        function scrollToPage(page) {
          var targetScroll = page * getPageWidth();
          carousel.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }
  
        function updateArrows() {
          if (!showArrows || !prevBtn || !nextBtn) return;
          prevBtn.disabled = state.currentPage <= 0 || state.totalPages === 0;
          nextBtn.disabled = state.currentPage >= state.totalPages - 1 || state.totalPages === 0;
        }
  
        function updateDots() {
          if (!showDots || !dotsContainer) return;
          dotsContainer.innerHTML = '';
          for (var i = 0; i < state.totalPages; i++) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'krs-fpc__dot';
            btn.setAttribute('aria-label', i18nPage + ' ' + (i + 1) + ' ' + i18nOf + ' ' + state.totalPages);
            if (i === state.currentPage) {
              btn.setAttribute('aria-current', 'true');
            }
            btn.addEventListener('click', function(idx) {
              return function() { scrollToPage(idx); };
            }(i));
            dotsContainer.appendChild(btn);
          }
        }
  
        function syncFromScroll() {
          state.currentPage = getCurrentPage();
          updateArrows();
          if (showDots && dotsContainer) {
            var dotBtns = dotsContainer.querySelectorAll('.krs-fpc__dot');
            dotBtns.forEach(function(btn, i) {
              if (i === state.currentPage) {
                btn.setAttribute('aria-current', 'true');
              } else {
                btn.removeAttribute('aria-current');
              }
            });
          }
        }
  
        function onScroll() {
          syncFromScroll();
        }
  
        function onResize() {
          updatePages();
          state.currentPage = getCurrentPage();
          syncFromScroll();
        }
  
        if (showArrows && prevBtn) {
          prevBtn.addEventListener('click', function() {
            if (state.currentPage > 0) scrollToPage(state.currentPage - 1);
          });
        }
        if (showArrows && nextBtn) {
          nextBtn.addEventListener('click', function() {
            if (state.currentPage < state.totalPages - 1) scrollToPage(state.currentPage + 1);
          });
        }
  
        carousel.addEventListener('scroll', onScroll);

        function tryCarouselArrowNav(e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          var t = e.target;
          var tag = (t && t.tagName) ? t.tagName.toLowerCase() : '';
          if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
          if (t.isContentEditable) return;
          if (t.closest && t.closest('a,button')) return;
          e.preventDefault();
          if (e.key === 'ArrowLeft' && prevBtn && !prevBtn.disabled) {
            scrollToPage(state.currentPage - 1);
          } else if (e.key === 'ArrowRight' && nextBtn && !nextBtn.disabled) {
            scrollToPage(state.currentPage + 1);
          }
        }

        carousel.addEventListener('keydown', tryCarouselArrowNav);
  
        state.resizeObserver = new ResizeObserver(function() {
          onResize();
        });
        state.resizeObserver.observe(root);
  
        root.querySelectorAll('.krs-fpc__favorite').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var isFavorite = btn.getAttribute('data-favorite') === 'true';
            btn.setAttribute('data-favorite', !isFavorite);
            btn.setAttribute('aria-label', !isFavorite ? i18nFavRemove : i18nFavAdd);
          });
        });
  
        updatePages();
        syncFromScroll();
        root.dataset.initialized = 'true';
  
        KRSFeaturedPropertiesCarousel.instances[sectionId] = state;
      }
    };
  
    window.KRSFeaturedPropertiesCarousel = KRSFeaturedPropertiesCarousel;
  })();
  